var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Town(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-town",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7190",
    "data-name": "Rectangle 7190",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "town-hall-svgrepo-com",
    d: "M19.612,6.2h-6.2V1.551L11.081,0,8.755,1.551V6.2h-6.2L1,7.755V9.306H21.163V7.755Zm-8.53-3.877a1.106,1.106,0,0,1,1.086,1.241.98.98,0,0,1-1.086,1.086A1.223,1.223,0,0,1,9.841,3.412,1.2,1.2,0,0,1,11.081,2.326Zm8.53,8.53H2.551v6.2L1,19.387v2.326H21.163V19.387l-1.551-2.326ZM7.2,19.387H5.653V12.408H7.2Zm4.653,0H10.306V12.408h1.551Zm4.653,0H14.959V12.408H16.51Z",
    transform: "translate(1 1)",
    fill: "#adb5b9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Town);
export default __webpack_public_path__ + "static/media/icon-24-town.a4686390f2e7ce88dd8ae9d5edd77d66.svg";
export { ForwardRef as ReactComponent };